/**
 * Helpers for moving a portion of a GA section between inventories.
 * A GA section can be split across exclusive offers; never drop the
 * whole section key just because some of its spots were selected.
 */

export const removeSelectedGaSeats = (
  gaSeatsMap = {},
  selectedBySection = {}
) => {
  const nextGaSeats = { ...gaSeatsMap }

  Object.entries(selectedBySection).forEach(([sectionId, selectedGaSeats]) => {
    if (!Array.isArray(nextGaSeats[sectionId])) return

    const selectedIds = new Set(selectedGaSeats)
    nextGaSeats[sectionId] = nextGaSeats[sectionId].filter(
      (seatId) => !selectedIds.has(seatId)
    )
  })

  return nextGaSeats
}

export const buildGaSelectionFromModal = (inventoryList = [], sectionId) => {
  const sources = {}

  inventoryList.forEach((obj) => {
    if (!obj?.key || !(obj.count > 0) || !Array.isArray(obj.gaSeats)) return
    sources[obj.key] = obj.gaSeats.slice(0, obj.count)
  })

  return {
    [sectionId]: sources,
  }
}

export const sectionHasAssignedGaSeats = (gaSeats, sectionId) =>
  Array.isArray(gaSeats?.[sectionId]) && gaSeats[sectionId].length > 0

export const sectionHasSelectedGaSeats = (sectionSelection) =>
  Boolean(
    sectionSelection &&
    Object.values(sectionSelection).some(
      (seats) => Array.isArray(seats) && seats.length > 0
    )
  )

export const getAssignedGaSpots = (
  sourceGaSeats,
  sectionId,
  fallbackSpots = []
) => {
  if (sectionHasAssignedGaSeats(sourceGaSeats, sectionId)) {
    return [...sourceGaSeats[sectionId]]
  }
  return [...fallbackSpots]
}
